import Loader from 'components/Spinner/Loader'

const ItemTipoBimLinkAssigned = ({ bimLink }) => {
  return (
    <li style={{ marginBottom: '1rem' }}>
      {bimLink.proyecto} - {bimLink.name}
    </li>
  )
}
const NotDeleteBimLink = ({ tiposBimLink, isLoading }) => {
  if (isLoading) {
    return (
      <div className="d-center w-100" style={{ flexWrap: 'nowrap' }}>
        <Loader size={24} />
      </div>
    )
  }
  return (
    <div className="delete-bimlink-container">
      <h2>Este BimLink ya está asociado</h2>
      <p>
        No se puede eliminar un bimlink que ha sido asociado con algún tipo.
        Elimina esta asociación y vuelve a intentarlo.
      </p>
      <p className="delete-bimlink-subtitle">
        Proyecto y tipo donde está asociado:
      </p>
      <ul className="delete-bimlink-tipos-list">
        {tiposBimLink.map(tipoBimLink => (
          <ItemTipoBimLinkAssigned bimLink={tipoBimLink} />
        ))}
      </ul>
    </div>
  )
}

export default NotDeleteBimLink
